import {db, Timestamp} from '../firebase'
import store from '../store/store'
import VueSimpleAlert from 'vue-simple-alert'
export default {
  async verificaCupomUsuarioLogado () {
    if (store.state.carrinho.dadosCupomDesconto != null) {
      if (store.state.usuario.usuario != null) {
        await db.collection('Clientes').doc(store.state.usuario.usuario.Email).collection('Cupons').where('NomeCupom', '==', store.state.carrinho.dadosCupomDesconto.NomeCupom).limit(1).get().then(async (querySnapshotCupom) => {
          if (querySnapshotCupom.empty === false) {
            VueSimpleAlert.fire({
              title: 'Cupom já utilizado',
              text: 'O Cupom ' + store.state.carrinho.dadosCupomDesconto.NomeCupom + ' já foi utilizado em sua conta',
              type: 'info'
            }).then(r => {
              setTimeout(() => store.dispatch('menu/toggleMenu', true), 1)
            })
            await this.destroiCupom()
          }
        })
      }
    }
  },

  async gravarCupomPagamentos (codigoPedido) {
    await db.collection('Pagamentos').doc(codigoPedido).update({
      'Cupom': store.state.carrinho.dadosCupomDesconto.NomeCupom,
      'CupomValor': store.state.carrinho.cupomDesconto
    })
    await db.collection('Clientes').doc(store.state.usuario.usuario.Email).collection('Pagamentos').doc(codigoPedido).update({
      'Cupom': store.state.carrinho.dadosCupomDesconto.NomeCupom,
      'CupomValor': store.state.carrinho.cupomDesconto
    })
  },

  async gravarCupomClientes () {
    if (store.state.usuario.usuario != null) {
      await db.collection('Clientes').doc(store.state.usuario.usuario.Email).collection('Cupons').add(store.state.carrinho.dadosCupomDesconto)
    } else {
      VueSimpleAlert.fire({
        title: 'Não foi possível aplicar o cupom',
        text: 'Por favor, realize o login para continuar',
        type: 'error'
      }).then(r => {
        this.destroiCupom()
        setTimeout(() => this.toggleMenu(true), 1)
      })
    }
  },

  async gravaCupomUtilizado (id, codigoPedido) {
    await db.collection('Cupom').doc(id).collection('Utilizados').doc(store.state.usuario.usuario.Email).set({
      'DataUtilizado': Timestamp.now(),
      'Usuario': store.state.usuario.usuario.Email,
      'CodigoPedido': codigoPedido
    })
  },

  async controlaEstoqueCupom (codigoPedido) {
    await db.collection('Cupom').where('NomeCupom', '==', store.state.carrinho.dadosCupomDesconto.NomeCupom).limit(1).get().then(async (querySnapshot) => {
      if (!querySnapshot.empty) {
        querySnapshot.forEach(async (doc) => {
          await db.collection('Cupom').doc(doc.id).update({
            'QtdCupom': doc.data().QtdCupom - 1
          })
          await this.gravaCupomUtilizado(doc.id, codigoPedido)
        })
      }
    })
  },

  destroiCupom () {
    store.dispatch('carrinho/destroiCupom')
  },

  async executaFuncoesCupom () {
    const idPedido = store.state.finalizarCompra.idPedido.toString().padStart(14, '0')
    await this.gravarCupomPagamentos(idPedido)
    await this.gravarCupomClientes()
    await this.controlaEstoqueCupom(idPedido)
    await this.destroiCupom()
  }
}



// WEBPACK FOOTER //
// ./src/methods/Cupom.js